<template>
  <div class="row content-block">
    <div class="col-12 col-lg-12" >
      <div class="embed-responsive embed-responsive-16by9" v-html="this.content.code.ru"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'video-embed',
    props: [
      'content',
      'static_content',
      'block_title',
      'fetchedData',
    ],
  }
</script>
